import { IrregularidadeService } from 'src/app/pages/cadastros/irregularidade/irregularidade.service';
import { AreaTecnica } from './../cadastros/areatecnica/areatecnica.model';
import { Component, OnInit, AfterContentInit } from '@angular/core';
import { SpvDetalhes } from 'src/app/models/spvDetalhes.model';
import { SpvService } from 'src/app/services/spv.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EncarregadoCB } from 'src/app/models/encarregadoCB.model';
import { FuncionarioService } from 'src/app/pages/cadastros/funcionario/funcionario.service';
import { Funcionario } from 'src/app/models/funcionario.model';
import { SpvAprovadoParaQualificar } from 'src/app/models/spv-para-qualificar.model';
import { SpvAprovadoCheckList } from 'src/app/models/spv-aprovado-checklist-model';
import { TipoCheckList } from 'src/app/models/tipoCheckList.model';
import { TipoCheckListService } from 'src/app/services/tipochecklist.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { CommandResult } from '../domain/commandResult';
import { AreaTecnicaService } from '../cadastros/areatecnica/areatecnica.service';
import { Photo } from '../os/fechar-os/photo.model';
import { UploadPhoto } from '../os/fechar-os/upload-photo.model';
import { FecharOSService } from '../os/fechar-os/fechar-os.service';
import { FotoBase64ViewModel } from '../domain/viewmodels.models';
import { Irregularidade } from '../domain/domain.model';
import { EmpreiteiraService } from '../cadastros/empreiteira/empreiteira.service';
import { Empreiteira } from 'src/app/models/empreiteira.model';




@Component({
  selector: 'app-programarservico-spv',
  templateUrl: './programar-servico.component.html',
  styleUrls: ['./programar-servico.component.scss'],
  providers: [SpvService, FuncionarioService, TipoCheckListService]
})
export class ProgramarServicoComponent implements OnInit, AfterContentInit {


  constructor(
    private spvService: SpvService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private funcionarioService: FuncionarioService,
    private tipoCheckListService: TipoCheckListService,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    private areasTecnicasService: AreaTecnicaService,
    private fechamentoOSService: FecharOSService,
    private irregularidadeService: IrregularidadeService,
    private empreiteiraService: EmpreiteiraService,
  ) { }

  iniciando = true;
  isProcessing = false;
  spvs: SpvDetalhes[] = undefined;
  spvSelecionada: SpvAprovadoParaQualificar = null;
  spvId = 0;
  voids: string[] = [];
  maximoLinhas = 10;
  encarregados: EncarregadoCB[] = [];
  funcionarios: Funcionario[] = [];
  funcionariosSelecionados: Funcionario[] = [];
  engenheiros: Funcionario[] = [];

  spvsAprovadosCheckLists: SpvAprovadoCheckList[] = [];
  tiposCheckLists: TipoCheckList[] = [];
  autorizacoes: UsuarioAutorizacoes;
  areasTecnicas: any[] = [];
  filtroAreaTecnicaId: number = 0;
  filtroAreaTecnicaDescricao: string = '';
  funcionariosListaGrid: any[] = [];
  irregularidades: Irregularidade[] = [];

  previewsPhotos: Photo[] = []; // armazena as photos em base 64 para exibição
  previewPhotoSelecionada: Photo; // dataUrl (base 64) da foto clicada
  uploadPhotos: UploadPhoto[] = [];

  autorizacaoAdicionarFoto: boolean;
  hasPendencia: boolean = false;
  someItemAvaliado: boolean = false; // verifica se algum dos itens selecionados já tenha sido avaliado por outro usuário logado



  form: FormGroup = null;
  formEmpreiteira: FormGroup;

  public totalOSsAGerar = 0;
  public spvsMarcados: SpvDetalhes[] = [];
  public itemComPendencia: boolean = false;
  empreiteiras: Empreiteira[] = [];
  public empreiteiraIdEmpty = false;

  ngOnInit() {
    this.resetForm();
    this.resetFormEmpreiteira();
    this.getAreasTecnicas();
    this.getIrregularidades();


    this.tipoCheckListService.getTiposCheckListComCheckLists().subscribe((response) => { this.tiposCheckLists = response; });

  }


  resetForm() {
    this.form = this.formBuilder.group({
      id: [0],
      engenheiroResponsavelId: [''],
      encarregadoResponsavelId: [''],
      observacoesGerais: [''],
      areaTecnicaId: ['', [Validators.required]],
      fimDeSemana: [false, [Validators.required]],
      tipo: [''],
      CheckListsServico: [],
      ColaboradoresServico: [],
      irregularidadeId: [''],
      spvsMarcados: [[]],
      tipoProgramacao: ['1']
    });

    if (this.engenheiros.length == 1) {
      this.form.get('engenheiroResponsavelId').setValue(this.engenheiros[0].id)
    } else {
      this.form.get('engenheiroResponsavelId').setValue('')
    }

  }

  resetFormEmpreiteira() {
    this.formEmpreiteira = this.formBuilder.group({
      empreiteiraId: [0],
    })

    this.getEmpreiteiras();
  }

  getEmpreiteiras() {
    this.empreiteiraService.getEmpreiteiras().subscribe((response) => {
      this.empreiteiras = response;
      this.formEmpreiteira.get('empreiteiraId').setValue(this.empreiteiras[0].id); //todo: Temporário 
      this.getSpvsParaQualificar();
      this.getEngenheirosPorEmpreiteira();
      this.getEncarregadosPorEmpreiteira();
      this.getListaFuncionariosPorEmpreteira();
    });
  }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('programar-servico');
    this.autorizacaoAdicionarFoto = this.usuarioService.getAutorizacoesEspecificaPorRota('ss-pt-programar-servico', 'adicionar-fotos-antes');
  }



  getIrregularidades() {

    this.irregularidadeService.getAll().subscribe(
      (response: Irregularidade[]) => {
        this.irregularidades = response;
      })

  }

  public getAreasTecnicas() {
    this.areasTecnicasService.list().subscribe(
      (response: any) => {
        this.areasTecnicas = response;
      });
  }


  getSpvsParaQualificar() {
    this.spvService.getSpvsParaQualificar(this.filtroAreaTecnicaId, Number(this.formEmpreiteira.get('empreiteiraId').value)).subscribe(
      (response: SpvDetalhes[]) => {
        this.spvs = response;
       
        this.hasPendencia = this.spvs.some(t => t.irregularidadeId != null);

        if (!this.someItemAvaliado) {
        if (this.spvsMarcados.length > 0) {
          this.spvsMarcados.forEach(t => {
            const itemSpv = this.spvs.find(s => s.spvId == t.spvId);
            itemSpv.marcado = true;
          })
        }
      }

        this.setVoids();
      },
      (err: any) => {
        this.toastr.error('Erro ao tentar obter SSs abertos');
      });
  }

  getEngenheirosPorEmpreiteira() {
    this.funcionarioService.getEngenheirosPorEmpreiteira(Number(this.formEmpreiteira.get('empreiteiraId').value))
      .subscribe((enghrs) => {
        this.engenheiros = enghrs;


        if (this.engenheiros.length == 1) {
          this.form.get('engenheiroResponsavelId').setValue(this.engenheiros[0].id)
        } else {
          this.form.get('engenheiroResponsavelId').setValue('')
        }

      });
  }

  getEncarregadosPorEmpreiteira() {
    this.funcionarioService.getEncarregadosPorEmpreiteira(Number(this.formEmpreiteira.get('empreiteiraId').value)).subscribe((encs) => {
      this.encarregados = encs;
    });
  }

  getListaFuncionariosPorEmpreteira() {
    this.funcionarioService.getListaFuncionariosPorEmpreteira(Number(this.formEmpreiteira.get('empreiteiraId').value)).subscribe((listasFuncs) => {
      this.funcionarios = listasFuncs;
      this.funcionariosSelecionados = [];
      this.funcionariosListaGrid = listasFuncs;

    });
  }

  getById(spvId: number, modal: any) {

    this.reset();
    this.isProcessing = true;

    this.spvService.getSpvAprovadoParaQualificar(spvId).subscribe((response) => {

      this.spvSelecionada = response;

      this.spvId = spvId;
      this.isProcessing = false;
      this.form.controls.observacoesGerais.setValue(this.spvSelecionada.observacoesGerais);
      this.form.controls.areaTecnicaId.setValue(this.spvSelecionada.areaTecnicaId);
      this.form.controls.tipo.setValue(this.spvSelecionada.tipo);
      this.form.get('irregularidadeId').setValue(this.spvSelecionada.irregularidadeId == null ? '' : this.spvSelecionada.irregularidadeId);

      this.setEnabledFieldsForm(this.spvSelecionada.irregularidadeId == null);

      this.uploadPhotos = response.uploadPhotos;

      this.fechamentoOSService.getArrayFotosBase64(this.uploadPhotos).subscribe(
        (responseFotos: FotoBase64ViewModel[]) => {
          responseFotos.forEach(foto => {
            this.previewsPhotos.push({ dataUrl: foto.base64String, name: foto.arquivoNome });
          })
        })

      this.modalService.open(modal, { windowClass: 'xlModal', backdrop: 'static' });
      return;

    });

  }


  reset() {

    this.resetForm();

    this.isProcessing = false;

    this.funcionariosListaGrid = this.funcionarios;
    this.funcionariosSelecionados = [];
    this.spvsAprovadosCheckLists = [];

    this.previewsPhotos = [];
    this.previewPhotoSelecionada = null;
    this.uploadPhotos = [];
    this.someItemAvaliado = false;
  }

  private setVoids() {

    this.voids = [];

    if (this.spvs.length < this.maximoLinhas) {
      for (let i = this.spvs.length; i < this.maximoLinhas; i++) { this.voids.push(''); }
    }
  }

  fecharModal() {
    this.modalService.dismissAll();
    this.reset();

  }


  setEnabledFieldsForm(enableForm: boolean) {

    if (enableForm) {
      this.form.controls.observacoesGerais.enable();
      this.form.controls.fimDeSemana.enable();
      this.form.controls.areaTecnicaId.enable();
      this.form.controls.engenheiroResponsavelId.enable();
      this.form.controls.encarregadoResponsavelId.enable();

      //this.resetForm();
    }
    else {

      this.form.controls.observacoesGerais.disable();
      this.form.controls.fimDeSemana.disable();
      this.form.controls.areaTecnicaId.disable();
      this.form.controls.engenheiroResponsavelId.disable();
      this.form.controls.encarregadoResponsavelId.disable();

    }

  }


  changeSituacaoPendencia() {
    this.setEnabledFieldsForm((this.form.get('irregularidadeId').value == '' && !this.itemComPendencia));
  }


  submit() {



    if (this.validForm()) {

      this.someItemAvaliado = false;

      this.isProcessing = true;

      const marcadoComoItemComPendencia = this.form.get('irregularidadeId').value != '' && !this.itemComPendencia;

      if (!this.itemComPendencia && !marcadoComoItemComPendencia) {

        const spvIds = this.spvsMarcados.map(t => t.spvId).toString();

        this.spvService.getSpvsParaQualificarMarcados(spvIds).subscribe((spvsMarcados: SpvDetalhes[]) => {

          this.spvsMarcados = spvsMarcados;

          this.form.controls.CheckListsServico.setValue(this.spvsAprovadosCheckLists.map(c => {
            return { checkListId: c.checkListId };
          }));

          this.form.controls.ColaboradoresServico.setValue(this.funcionariosSelecionados.map(f => {
            return { funcionarioId: f.id };
          }));

          this.form.controls.spvsMarcados.setValue(this.spvsMarcados.filter((t => t.qualificado === false && t.irregularidadeId === null)));

          this.form.controls['id'].setValue(0);

          
          this.spvService.qualificarSpv(this.form.value).subscribe(

            (response: CommandResult) => {
              if (response.success === true) {

                if (response.message) {
                  this.toastr.success(response.message);
                }
                this.reset();
                this.totalOSsAGerar = 0;
                this.getSpvsParaQualificar();

                this.spvsMarcados = this.spvsMarcados.filter(t => (t.qualificado == true || t.irregularidadeId != null) );

                if (this.spvsMarcados.length == 0) {
                  this.spvsMarcados = [];
                  this.modalService.dismissAll();
                } else {
                  this.someItemAvaliado = true;
                }

              } else {
                this.toastr.error(response.message);
              }
              this.isProcessing = false;
            },
            (exception: any) => {
              this.showErrorExecption(exception);
              this.isProcessing = false
            },
            () => this.isProcessing = false
          );

        })

      } else {

        this.spvService.setIrregulariadeSpv(this.spvSelecionada.spvId, Number(this.form.get('irregularidadeId').value)).subscribe(
          (response: boolean) => {
            if (response == false) {
              this.toastr.error("Ocorreu um erro ao tentar confirmar a irregularidade");
            } else {
              this.reset();
              this.getSpvsParaQualificar();
              this.totalOSsAGerar = this.totalOSsAGerar - 1;

              this.spvsMarcados = this.spvsMarcados.filter(t => t.spvId != this.spvSelecionada.spvId);

              this.modalService.dismissAll();
              this.itemComPendencia = false;
            }
          }
        );

      }
    }

  }

  validForm() {

    let valid = true;

    if (this.form.get('irregularidadeId').value == '' && this.itemComPendencia == false) {

      if (this.form.get('encarregadoResponsavelId').value === '') {
        this.form.get('encarregadoResponsavelId').setErrors({ isNotValidEncarregadoResponsavel: true });
        valid = false;
      }
    }

    
    return valid;

  }


  /* **************** CheckList ******************* */

  openModalChecklist(modal) { this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static' }); }

  adicionarRemoverCheckLists(checkListId: number) {
    /* Verifica se check list já incluído na lista */
    const jaInserido = this.spvsAprovadosCheckLists.find(t => t.checkListId === checkListId);

    // adiciona um check lista na coleção se não tiver e remove se tiveer
    if (jaInserido === undefined) {
      this.spvsAprovadosCheckLists.push(new SpvAprovadoCheckList(checkListId, 0));
    } else {
      this.spvsAprovadosCheckLists = this.spvsAprovadosCheckLists.filter(t => t.checkListId !== checkListId);
    }

  }

  checkListJaAdicionado(checkListId: number) {
    const jaInserido = this.spvsAprovadosCheckLists.find(t => t.checkListId === checkListId);
    return jaInserido !== undefined;
  }


  /* *** Colaboradores  *** */

  openModalColaboradores(modal) { this.modalService.open(modal, { windowClass: 'lgModal', backdrop: 'static' }); }

  selectColaborador(id: number) {

    this.funcionariosListaGrid.forEach(f => { if (f.id === Number(id)) { f.marcado = !f.marcado; } });
  }

  adicionarColaboradores(id: number) {
    this.funcionariosListaGrid.forEach(f => {
      if (f.marcado) {
        f.marcado = false;
        this.funcionariosSelecionados.push(f);
        this.funcionariosListaGrid = this.funcionariosListaGrid.filter(f2 => f2.id !== f.id);
      }
    });

    // reordena pelo nome os colaboradores após a inserção
    this.funcionariosSelecionados.sort((f1, f2) => {
      if (f1.nome < f2.nome) { return -1; }
      if (f1.nome > f2.nome) { return 1; }
      return 0;
    });


  }

  removerColaborador(f: Funcionario) {
    this.funcionarios.push(f);
    this.funcionariosListaGrid.push(f);
    this.funcionariosSelecionados = this.funcionariosSelecionados.filter(f2 => f2.id !== f.id);

    // reordena pelo nome os funcionário após o retorno
    this.funcionarios.sort((f1, f2) => {
      if (f1.nome < f2.nome) { return -1; }
      if (f1.nome > f2.nome) { return 1; }
      return 0;
    });

    // reordena pelo nome os funcionário após o retorno
    this.funcionariosListaGrid.sort((f1, f2) => {
      if (f1.nome < f2.nome) { return -1; }
      if (f1.nome > f2.nome) { return 1; }
      return 0;
    });

  }


  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) { msg = 'A aplicação não conseguiu se conectar ao Servidor'; }
    if (Number(exception.status) === 500) { msg = 'O Servidor gerou um erro de processamento'; }
    this.toastr.error(`<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`);
  }


  changeAreaTecnica(areaTecnicaId: number, areaTecnicaDescricao: string) {

    this.filtroAreaTecnicaId = Number(areaTecnicaId);
    this.filtroAreaTecnicaDescricao = areaTecnicaDescricao;
    this.getSpvsParaQualificar();
  }


  limparDataListFuncionarios() {

    (document.getElementById('datalistFuncionarios') as HTMLInputElement).value = '';
    this.funcionariosListaGrid = this.funcionarios;
  }

  changeDataListFuncionarios(value: string,) {
    if (value != '') {
      this.funcionariosListaGrid = this.funcionarios
        .filter(t => t.nome.toLowerCase().includes(value.toLowerCase())
          || t.matricula.toLowerCase().includes(value.toLocaleLowerCase())
        );
    }
  }


  openModalExibePhoto(modal, pview) {
    this.previewPhotoSelecionada = pview;
    this.modalService.open(modal, { windowClass: 'zoomPhotoModal', backdrop: 'static' });
  }

  selecionarTodos() {

    this.spvs.forEach(s => {
      if (!s.irregularidadeId) {
        s.marcado = true;
      }
    });

    this.spvsMarcados = this.spvs.filter(t => t.marcado);
    this.totalOSsAGerar = this.spvs.filter(t => t.marcado === true).length;

  }

  selecionarNenhum() {
    this.spvs.forEach(s => s.marcado = false);

    this.spvs.forEach(s => {
      if (!s.irregularidadeId) {
        s.marcado = false;
      }
    });

    this.spvsMarcados = [];
    this.totalOSsAGerar = 0;
  }

  selecionarItem(spvId: number, modal: any) {

    this.itemComPendencia = false;

    const selecionado = this.spvs.find(t => t.spvId === spvId);

    if (selecionado.irregularidadeId) {
      if (modal != null) {
        this.getById(spvId, modal);
      }
      this.itemComPendencia = true;
      return;
    }


    selecionado.marcado = !selecionado.marcado;

    this.spvsMarcados = this.spvs.filter(t => t.marcado);
    this.totalOSsAGerar = this.spvsMarcados.length;


  }



  programar(modal: any) {
    if (this.spvsMarcados.length == 1) {
      const spvId = this.spvsMarcados[0].spvId;
      this.getById(spvId, modal);
    } else {
      // vários selecionados
      this.form.get('fimDeSemana').setValue(null);
      this.form.get('areaTecnicaId').setValue('');
      this.modalService.open(modal, { windowClass: 'xlModal', backdrop: 'static' });
    }

  }

}
